import { MRT_RowSelectionState } from "material-react-table";
import { BookingRequestsStatus } from "../../../BookingRequest/typings/booking-requests.types";
import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";
import {
  DetailDataChanges,
  UpdatedServiceOrderRequest
} from "../partial/OrderRequestDetailDialog.partial";
import {
  ServiceDeliveryStatus,
  ServiceType
} from "../../../../features/Booking-Form/typings/booking-service-administration.types";

export const getSelectedItems = <T extends { id: number }>(
  items: T[] | undefined,
  selection: Record<string, boolean>
): T[] => {
  return items?.filter(item => selection[item.id.toString()]) ?? [];
};

export const applyEdits = <
  T extends { id: number; quantity: number; status: BookingRequestsStatus }
>(
  items: T[],
  edits: { id: number; newQty: number; status: BookingRequestsStatus }[]
): T[] => {
  return items.map(item => {
    const edit = edits.find(e => e.id === item.id);
    return edit ? { ...item, quantity: edit.newQty, status: edit.status } : item;
  });
};

export const saveDetailData = ({
  state,
  actions
}: {
  state: {
    editedData: DetailedServiceBookingData | null;
    cateringRowSelection: MRT_RowSelectionState;
    equipmentRowSelection: MRT_RowSelectionState;
    roomlayoutRowSelection: MRT_RowSelectionState;
    editedRecord: DetailDataChanges[];
  };
  actions: {
    updateOrderRequest: (
      targetBookingId: string,
      changedDeliveryStatus: ServiceDeliveryStatus,
      changes: UpdatedServiceOrderRequest
    ) => Promise<void>;
    setEditedData: (e: DetailedServiceBookingData | null) => void;
  };
}) => {
  const {
    editedData,
    cateringRowSelection,
    equipmentRowSelection,
    roomlayoutRowSelection,
    editedRecord
  } = state;
  const { updateOrderRequest } = actions;
  if (!editedData) return;

  const selectedCatering = getSelectedItems(editedData.caterings, cateringRowSelection);
  const selectedEquipment = getSelectedItems(editedData.equipments, equipmentRowSelection);
  const selectedRoomlayout = getSelectedItems(editedData.roomLayouts, roomlayoutRowSelection);

  let updatedCatering = selectedCatering;
  let updatedEquipment = selectedEquipment;
  let updatedRoomlayout = selectedRoomlayout;

  if (editedRecord.length > 0) {
    const editedCaterings = editedRecord.filter(record => record.type === ServiceType.Catering);
    const editedEquipments = editedRecord.filter(
      record => record.type === ServiceType.Bookable_Equipment
    );
    const editedLayout = editedRecord.filter(record => record.type === ServiceType.Room_Layout);

    updatedCatering = applyEdits(updatedCatering, editedCaterings);
    updatedEquipment = applyEdits(updatedEquipment, editedEquipments);
    updatedRoomlayout = applyEdits(updatedRoomlayout, editedLayout);
  }

  const updated: UpdatedServiceOrderRequest = {
    caterings: updatedCatering,
    equipments: updatedEquipment,
    roomLayouts: updatedRoomlayout
  };
  const targetBookingId = editedData.bookingId;
  const updatedDeliveryStatus = editedData.deliveryStatus;

  // POST call with updated data
  updateOrderRequest(targetBookingId, updatedDeliveryStatus, updated);
};
